import React from 'react';
import NoRowsWrapper from '@/components/table/NoRowsWrapper';
import Events from '@/datasets/conditions/hooks/events';
import RequestWorkspacesTable from './RequestWorkspacesTable';
import RequestWorkspaceList from './RequestWorkspaceList';
import RequestWorkspaceSegment from './RequestWorkspaceSegment';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const SelectWorkspaces = ({ category, code, compact }) => {
  const state = Selectors.useSelectWorkspaces({ category, code });
  const showConditions = Events.useShowDatasetConditions({ code: state.sourceCode });
  Fetch.useFetchRequestWorkspaces({ category, code, ...state }, state.readStatus);
  const ref = React.useRef(null);

  if (compact) {
    return (
      <RequestWorkspaceSegment category={category} code={code}>
        <RequestWorkspaceList
          category={category}
          code={code}
          hasConditions={state.hasConditions}
          onClick={() => showConditions(state)}
        />
      </RequestWorkspaceSegment>
    );
  }

  return (
    <div className="ReactTable aridhia-select-workspace-workspaces" ref={ref}>
      <RequestWorkspaceSegment category={category} code={code}>
        <NoRowsWrapper
          buttonIcon="clipboard list"
          canCreate={state.hasConditions}
          entity="workspace"
          icon="cube"
          items={state.workspaces}
          onClick={() => showConditions(state)}
          readStatus={[state.readStatus, state.locationsReadStatus]}
          showChildrenIfNoRows
        >
          <RequestWorkspacesTable category={category} code={code} hasConditions={state.hasConditions} />
        </NoRowsWrapper>
      </RequestWorkspaceSegment>
    </div>
  );
};

export default SelectWorkspaces;
